module.exports = __webpack_public_path__ + "img/featured_icon.9803cae0.svg";